import axios from 'axios';
import { errorHandler } from './libs/lib.js';

const baseurl = 'borrowerdisbursementdashboard';

function buildQuery(obj, keys) {
    let str = '';
    for (const key of keys) {
        if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') {
            str += str ? '&' : '?';
            str += `${key}=${encodeURIComponent(obj[key])}`;
        }
    }
    return str;
}

const filterKeys = ['date_from', 'date_to', 'pjxkey'];

export default {
    summary(filter = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const qs = buildQuery(filter, filterKeys);
                const { data } = await axios.get(`${baseurl}/summary${qs}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    monthlyTrend(filter = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const qs = buildQuery(filter, filterKeys);
                const { data } = await axios.get(`${baseurl}/monthly-trend${qs}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    dpdDistribution(filter = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const qs = buildQuery(filter, filterKeys);
                const { data } = await axios.get(`${baseurl}/dpd-distribution${qs}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    statusBreakdown(filter = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const qs = buildQuery(filter, filterKeys);
                const { data } = await axios.get(`${baseurl}/status-breakdown${qs}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    productBreakdown(filter = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const qs = buildQuery(filter, filterKeys);
                const { data } = await axios.get(`${baseurl}/product-breakdown${qs}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    topBorrowers(filter = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const qs = buildQuery(filter, [...filterKeys, 'limit']);
                const { data } = await axios.get(`${baseurl}/top-borrowers${qs}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    delinquent(filter = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const qs = buildQuery(filter, [...filterKeys, 'min_dpd', 'limit']);
                const { data } = await axios.get(`${baseurl}/delinquent${qs}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    pjxkeyList() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/pjxkey-list`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }
};
